import store from '@/store'

export const loggedIn = store.getters[`accounts/loggedIn`]

export const storeBattle = (to, from, next) => {
  window.localStorage.setItem(`recentBattle`, to.params.battle)
  next()
}

export const redirectIfLoggedIn = newTo => (to, from, next) => {
  if (store.getters[`accounts/loggedIn`]) next(newTo)
  next()
}

export const accessIfLoggedIn = (to, from, next) => {
  if (
    to.matched.some(record => record.meta.requiresAuth) &&
    !store.getters[`accounts/loggedIn`]
  )
    next(`login`)
  next()
}

export const accessIfBattleSet = (to, from, next) => {
  if (!window.localStorage.getItem(`recentBattle`)) {
    next(`battles`)
  } else {
    next()
  }
}
